export default __webpack_public_path__ + "static/media/services_wedding.608f2882.jpg";